import SearchBar from 'map/components/searchBar'
import SearchResults from 'map/components/searchResults/index'
import Map from 'map/components/map'
import styles from './styles.module.scss'

const MapView = () => (
    <div className={styles.mapView}>
        <div className={styles.searchBarContainer}>
            <SearchBar />
        </div>
        <div className={styles.bottomContainer}>
            <div className={styles.searchResultsContainer}>
                <SearchResults />
            </div>
            <div className={styles.mapContainer}>
                <Map />
            </div>
        </div>
    </div>
)

export default MapView
